"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.selectMessages = exports.mapStateToProps = exports.bootstrap = exports.localization = exports.DEFAULT_STATE = void 0;
const immutable_1 = require("immutable");
exports.DEFAULT_STATE = immutable_1.fromJS({
    locale: 'en-US',
    messageProperties: {},
    supportedLocales: []
});
function localization(state = exports.DEFAULT_STATE) {
    return state;
}
exports.localization = localization;
function bootstrap({ locale, messageProperties, supportedLocales }) {
    return immutable_1.fromJS({
        localization: {
            locale,
            messageProperties,
            supportedLocales
        }
    });
}
exports.bootstrap = bootstrap;
function mapStateToProps(reducer) {
    return state => {
        const locState = state.get(reducer);
        return {
            messages: locState.get('messageProperties')
        };
    };
}
exports.mapStateToProps = mapStateToProps;
const selectMessages = state => state.getIn(['localization', 'messageProperties']);
exports.selectMessages = selectMessages;
//# sourceMappingURL=localization.reducer.js.map